import React from 'react'
import {Icon} from '@chakra-ui/react'

const ViewFinderIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17ZM12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 2.04938V0H13V2.04938C17.7244 2.51844 21.4816 6.27558 21.9506 11H24V13H21.9506C21.4816 17.7244 17.7244 21.4816 13 21.9506V24H11V21.9506C6.27558 21.4816 2.51844 17.7244 2.04938 13H0V11H2.04938C2.51844 6.27558 6.27558 2.51844 11 2.04938ZM12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default ViewFinderIcon
